module.exports = __webpack_public_path__ + "static/media/blueBg.0c78c257.jpg";